import React, { useState, useEffect } from "react";
import "./index.scss";
import FormGenerator from "../../core/form-generator";
import { generateYearList, getUserFormConfig, PERFORMER_TYPE } from "./config";
import { Box } from "@mui/material";
import { handleFormValidation, PAGE_LIMIT } from "../../utils";
import CustomButtonComponent from "../../core/custom-button";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { monthOptions } from "../../pages/oem/training/training-report/helper";

const CreatePerformer = ({ setIsCreate, loadData, editData }) => {
  const [formData, setFormData] = useState({
    year: { label: new Date().getFullYear(), value: new Date().getFullYear() },
  });
  const [errors, setErrors] = useState({});
  const [usersList, setUsersList] = useState([]);
  const resetHandler = () => {
    setFormData({});
    loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
  };
  const submitHandler = () => {
    const isValid = handleFormValidation(
      getUserFormConfig(usersList),
      setErrors,
      formData
    );
    if (isValid) {
      if (formData?.type === "MONTH" && !formData?.month) {
        toast.error("Month is required");
        return;
      }

      const payload = {
        ...formData,
        type: formData?.type?.value,
        user: formData?.user?.value,
        year: formData?.year?.value,
        month: formData?.month?.value?.toUpperCase(),
      };

      if (editData?.id) {
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.PERFORMER}/${editData.id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Updated Successfully");
              resetHandler();
              setIsCreate(false);
            }
          })
          .catch((err) => console.error(err));
      } else {
        invokeApi(
          HTTP_METHODS.POST,
          `${HOSTNAME}${REST_URLS.PERFORMER}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Updated Successfully");
              resetHandler();
              setIsCreate(false);
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  const getUserList = () => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.USERS}`, null, {
      limit: 200,
    })
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          const result = res?.results?.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setUsersList(result);
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    if (editData?.id) {
      const { user, type, month, year, description } = editData;

      setFormData((prevVal) => ({
        ...prevVal,
        user: usersList.find((ele) => ele.value === user?.id),
        type: PERFORMER_TYPE.find((ele) => ele.value === type),
        month: monthOptions.find(
          (ele) =>
            ele.value ===
            month?.charAt(0)?.toUpperCase() + month?.slice(1)?.toLowerCase()
        ),
        year: generateYearList().find((ele) => ele.value === `${year}`),
        description,
      }));
    }
  }, [editData, usersList]);

  useEffect(() => {
    getUserList();
  }, []);
  return (
    <div>
      <div className="form-con" style={{ width: "100%" }}>
        <FormGenerator
          config={getUserFormConfig(usersList)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 5,
            mb: 2,
            gridGap: "1rem",
            alignItems: "center",
          }}
        >
          <CustomButtonComponent
            variant="contained"
            color="primary"
            sx={{ width: "150px" }}
            onClick={submitHandler}
          >
            Submit
          </CustomButtonComponent>
        </Box>
      </div>
    </div>
  );
};

export default CreatePerformer;
